import { apiRequest } from '../config/api';

export interface MotivoOcorrencia {
  id: string;
  nome: string;
  descricao?: string;
  ativo: boolean;
  created_at: string;
  updated_at: string;
}

class MotivosOcorrenciaServiceAPI {
  // Buscar todos os motivos
  async buscarTodos(ativo?: boolean): Promise<MotivoOcorrencia[]> {
    const params = new URLSearchParams();
    if (ativo !== undefined) params.append('ativo', ativo.toString());

    const response = await apiRequest(`/motivos-ocorrencia?${params}`);
    return response.data || [];
  }

  // Buscar motivo por ID
  async buscarPorId(id: string): Promise<MotivoOcorrencia | null> {
    try {
      const response = await apiRequest(`/motivos-ocorrencia/${id}`);
      return response.data || null;
    } catch (error) {
      return null;
    }
  }

  // Criar motivo
  async criar(motivo: Omit<MotivoOcorrencia, 'id' | 'created_at' | 'updated_at'>): Promise<MotivoOcorrencia> {
    const response = await apiRequest('/motivos-ocorrencia', {
      method: 'POST',
      body: JSON.stringify(motivo)
    });
    return response.data;
  }

  // Atualizar motivo
  async atualizar(id: string, dados: Partial<MotivoOcorrencia>): Promise<MotivoOcorrencia> {
    const response = await apiRequest(`/motivos-ocorrencia/${id}`, {
      method: 'PUT',
      body: JSON.stringify(dados)
    });
    return response.data;
  }

  // Ativar/Desativar motivo
  async alternarStatus(id: string, ativo: boolean): Promise<MotivoOcorrencia> {
    const response = await apiRequest(`/motivos-ocorrencia/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ ativo })
    });
    return response.data;
  }

  // Excluir motivo
  async excluir(id: string): Promise<void> {
    await apiRequest(`/motivos-ocorrencia/${id}`, {
      method: 'DELETE'
    });
  }

  // Verificar se nome já existe
  async nomeExiste(nome: string, idExcluir?: string): Promise<boolean> {
    const motivos = await this.buscarTodos();
    return motivos.some(m => 
      m.nome.toLowerCase() === nome.toLowerCase() && m.id !== idExcluir
    );
  }
}

export default new MotivosOcorrenciaServiceAPI();
